import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bd-footer__area pt-100 pb-40">
      <div className="container">
        <div className="row justify-content-between">
          {/* Logo Section */}
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <div className="bd-footer__widget mb-50 text-center text-lg-start">
              <div className="bd-footer__logo mb-20">
                <Link to="/">
                  <img
                    src="/assets/img/a1-img/Logo.png"
                    width="140"
                    alt="footer-logo"
                  />
                </Link>
              </div>
              <p className="text-white small">
                Be the first to taste our fresh bakes, sweet surprises, and
                limited-time treats.
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-xl-2 col-lg-4 col-md-6 col-sm-6">
            <div className="bd-footer__widget mb-50">
              <h4 className="bd-footer__widget-title text-white">
                Quick Links
              </h4>
              <ul className="bd-footer__link list-unstyled">
                {[
                  { label: "Home", path: "/" },
                  { label: "Shop Now", path: "/categories" },
                  { label: "About Us", path: "/aboutus" },
                  { label: "Contact Us", path: "/contact-us" },
                  // { label: "Franchise", path: "/franchise" },
                ].map((item, index) => (
                  <li key={index} className="mb-10">
                    <Link to={item.path}>{item.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Categories */}
          <div className="col-xl-2 col-lg-4 col-md-6 col-sm-6">
            <div className="bd-footer__widget mb-50">
              <h4 className="bd-footer__widget-title text-white">Categories</h4>
              <ul className="bd-footer__link list-unstyled">
                {[
                  { label: "Sweets", path: "/categories/sweets" },
                  {
                    label: "Crunchies & Savouries",
                    path: "/categories/savouries-and-crunchies",
                  },
                  { label: "Combo Packs", path: "/categories/combos" },
                  {
                    label: "Karupatti Sweets",
                    path: "/categories/karupatti-sweets",
                  },
                ].map((item, index) => (
                  <li key={index} className="mb-10">
                    <Link to={item.path}>{item.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Information */}
          <div className="col-xl-2 col-lg-4 col-md-6 col-sm-6">
            <div className="bd-footer__widget mb-50">
              <h4 className="bd-footer__widget-title text-white">
                Information
              </h4>
              <ul className="bd-footer__link list-unstyled">
                {[
                  { label: "Terms & Conditions", path: "/terms-of-service" },
                  { label: "Privacy Policy", path: "/privacy-policy" },
                  { label: "Refund Policy", path: "/refund-policy" },
                  { label: "Shipping Policy", path: "/shipping-policy" },
                ].map((item, index) => (
                  <li key={index} className="mb-10">
                    <Link to={item.path}>{item.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Social Section */}
          <div className="col-xl-3 col-lg-12 col-md-12">
            <div className="bd-footer__widget mb-50 text-center text-xl-start">
              <h4 className="bd-footer__widget-title text-white mb-20">
                Connect With Us
              </h4>

              <div className="social-icons">
              <ul className="d-flex justify-content-center justify-content-xl-start gap-3 list-unstyled">
                <li>
                  <a href="https://www.facebook.com/a1sweeetsmadurai/">
                    <img
                      src="/assets/img/a1-img/social_icons/facebook.png"
                      alt="Facebook"
                      style={{ width: "30px", height: "30px" }}
                    />
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/@a1sweetbakery500">
                    <img
                      src="/assets/img/a1-img/social_icons/youtube.png"
                      alt="YouTube"
                      style={{ width: "30px", height: "30px" }}
                    />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/a1bakeryandsweets/">
                    <img
                      src="/assets/img/a1-img/social_icons/insta.png"
                      alt="Instagram"
                      style={{ width: "28px", height: "28px" }}
                    />
                  </a>
                </li>
                <li>
                  <a href="https://wa.me/919751336638">
                    <img
                      src="/assets/img/a1-img/social_icons/whatsapp.png"
                      alt="WhatsApp"
                      style={{ width: "28px", height: "28px" }}
                    />
                  </a>
                </li>
              </ul>
            </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="bd-footer__copyright border-top pt-30 mt-20 text-center">
              <p className="text-white mb-0 small">
                &copy;2026 All right reserved. Build by S2B INNOVATION AND
                TECHNOLOGIES
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
